var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"app-icon",style:({ width: _vm.size + 'px', height: _vm.size + 'px' })},[(_vm.iconSrc)?_c('img',{staticClass:"icon-img",attrs:{"src":_vm.iconSrc,"alt":_vm.name}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }